import React from 'react';
import SEO from '../components/SEO';
import EmbeddedWheelOfNames from '../components/wheel-of-names/EmbeddedWheelOfNames';

export default EmbeddedWheelOfNames;

export const Head = () => (
  <SEO
    title="Embedded Wheel of Names | Random Name Picker"
    description="Wheel of Names is a random name picker tool. Spin the wheel. Perfect for classroom activities, raffles, and contests. Free & ad-free! By Seating Chart Maker."
    image="/wheel-of-names-05-24.jpg"
    noindex={true}
  />
);
